import { render } from "./ValoresSection.vue?vue&type=template&id=d66760a0&scoped=true&lang=pug"
import script from "./ValoresSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ValoresSection.vue?vue&type=script&setup=true&lang=js"

import "./ValoresSection.vue?vue&type=style&index=0&id=d66760a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66760a0"]])

export default __exports__